export default __webpack_public_path__ + "static/LeanBeginnerGuide-bbfe7ecf53e75270aceed78e39750fc7.jpeg";